import { render, staticRenderFns } from "./RbdSvgIcon.vue?vue&type=template&id=3db8c6c8&scoped=true"
import script from "./RbdSvgIcon.vue?vue&type=script&lang=js"
export * from "./RbdSvgIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db8c6c8",
  null
  
)

export default component.exports